import { GameCardTimer } from 'src/components/GameCard/components/GameCardTimer'
import type { MarbleGame } from 'src/types/domain/Game'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { Button } from 'src/components/Button'

type Props = Readonly<{
  isScheduled: boolean
  isCurrent: boolean
  game: MarbleGame
  onClick: () => void
}>

export function TrackHighlightButton({ isScheduled, isCurrent, game, onClick }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  if (isScheduled) {
    return (
      <div className="show-track-highlight-buttons button-scheduled">
        <button>
          <GameCardTimer race={game.races[0]} />
        </button>
      </div>
    )
  }

  if (isCurrent) {
    return (
      <div className="show-track-highlight-buttons button-current">
        <button>{t('Current Track')}</button>
      </div>
    )
  }

  return (
    <div className="show-track-highlight-buttons">
      <Button onClick={onClick} useDefaultClasses={false}>
        {t('Play Now')}
      </Button>
    </div>
  )
}
